import axios from "axios";
import { message as notificationMessage } from "components/Messages/Messages";

export const send_email = async (subject: string, message: string, to_email: string) => {
  try {
    await axios.post("/send-email/", {
      subject,
      message,
      to_email,
    });
    notificationMessage("success", "Velykket!", "Mailen din er sendt");
  } catch {
    return notificationMessage("error", "En feil har oppstått", "Kunne ikke sende mail, prøv igjen.");
  }
};
